import { useEffect, useState } from "react";
import { adminApi } from "@/api/admin";

/** Interruttore globale: quando OFF, nessuna pratica parte automaticamente verso A2A
 * (il cron di auto-invio fa no-op). GET all'apertura, PUT al click. */
export function AutoInvioSwitch() {
  const [enabled, setEnabled] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    adminApi.getAutoInvio()
      .then((res) => setEnabled(res.enabled))
      .catch(() => setError(true))
      .finally(() => setLoaded(true));
  }, []);

  async function handleToggle() {
    const next = !enabled;
    setEnabled(next);
    setError(false);
    setSaving(true);
    try {
      const res = await adminApi.setAutoInvio(next);
      setEnabled(res.enabled);
    } catch {
      setEnabled(!next); // revert su errore
      setError(true);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="bg-card border border-border rounded-xl p-4 flex items-center justify-between gap-4">
      <div>
        <div className="text-sm font-medium">Auto-invio A2A</div>
        <p className="text-xs text-muted-foreground mt-0.5">
          Se OFF, nessuna pratica parte automaticamente verso A2A.
        </p>
        {error && (
          <p className="text-xs text-amber-700 mt-1">
            Errore di comunicazione con il server. Riprova.
          </p>
        )}
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        aria-label="Auto-invio A2A"
        disabled={!loaded || saving}
        onClick={handleToggle}
        className={`relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50 disabled:opacity-50 disabled:cursor-not-allowed ${
          enabled ? "bg-primary" : "bg-input"
        }`}
      >
        <span
          className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform ${
            enabled ? "translate-x-4" : "translate-x-0"
          }`}
        />
      </button>
    </div>
  );
}
